/* eslint-disable import/prefer-default-export */
const announceMessage = (message) => {
  let alertStatusMessage = document.getElementById('formStatusMessage');
  // Has screenreader alert message already been appended to the page?
  if (alertStatusMessage) {
    // Then remove
    alertStatusMessage.remove();
  }
  // And recreate so it's re-read
  const body = document.querySelector('body');
  const div = document.createElement('div');
  div.id = 'formStatusMessage';
  div.classList.add('sr-only');
  div.setAttribute('role', 'alert');
  body.appendChild(div);
  alertStatusMessage = document.getElementById('formStatusMessage');
  // Set message
  alertStatusMessage.innerHTML = message;
};

export {
  announceMessage,
};
/* eslint-enable import/prefer-default-export */

